import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/http/base-http.service';
import { IAddTeamMember } from '@modules/projects/shared/interfaces/add-team-member.interface';
import { Config } from '@shared/configs/config';
import { catchError, EMPTY, Observable, tap } from 'rxjs';
import { Project } from '@modules/projects/shared/models/project.model';

@Injectable({ providedIn: 'root' })
export class ProjectTeamService extends BaseHttpService {
  constructor() {
    super();
  }

  addTeamMember(data: IAddTeamMember, projectId: number): Observable<Project> {
    const { hourlyRate } = data;
    const url = `${Config.API}/project/${projectId}/employee`;
    return this.post(url, {
      ...data,
      ...(hourlyRate || Number(hourlyRate) === 0 ? { hourlyRate: Number(hourlyRate) * 100 } : {})
    }).pipe(
      tap((project: Project) => this.s.success(this.t.instant('ProjectTeam.Manage.successAddingTeamMember'))),
      catchError(() => {
        this.s.error(this.t.instant('ProjectTeam.Manage.errorAddingTeamMember'));
        return EMPTY;
      })
    );
  }

  removeTeamMember(employeeId: number, projectId: number) {
    const url = `${Config.API}/project/${projectId}/employee/${employeeId}`;
    return this.delete(url, false).pipe(
      tap(() => this.s.success(this.t.instant('ProjectTeam.List.removedSuccess'))),
      catchError(() => {
        this.s.error(this.t.instant('ProjectTeam.List.removedError'));
        return EMPTY;
      })
    );
  }
}
